import { render } from "./appButton.vue?vue&type=template&id=65e95105"
import script from "./appButton.vue?vue&type=script&lang=js"
export * from "./appButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__